import React from 'react'
import { Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: ({ padding }) => theme.spacing(padding),
    margin: '0 auto',
    backgroundColor: 'transparent',
  },
}))

const PaperWithPadding = ({
  children,
  padding = 2,
  className = '',
  ...rest
}) => {
  const classes = useStyles({ padding })

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Paper
      elevation={0}
      square
      className={className}
      classes={{ root: classes.root }}
      {...rest}
    >
      {children}
    </Paper>
  )
}

export default PaperWithPadding
